"use client";

import { InfoTextListBlockProps } from "@/page-builder/fragments/InfoTextListBlock/types";
import { InfoBackgroudWrapper } from "../../InfoBackgroudWrapper";
import { renderRichTextAsHTML } from "@/components/molecules/Heading";

export const InfoTextListBlockContent = (data: InfoTextListBlockProps) => {
  return (
    <InfoBackgroudWrapper>
        <div>
            <div className="flex flex-col gap-16 xl:grid xl:grid-cols-[40%_60%] xl:items-start xl:gap-32">
              <div>{renderRichTextAsHTML(
                data?.title,
                false,
                "text-neutral-900",
                "text-xl-regular"
                )}</div>
              <div className="grid grid-cols-2 gap-32">
                {data?.items.map((item, index) => (
                    <div key={index} className="flex flex-col ">
                  <span className="text-[60px] font-bold leading-[56px] md:leading-[100px] text-primary-600">
                    {item?.title}
                  </span>
                  <span className="mt-16 md:mt-0 text-m-regular">
                    {item?.description}
                  </span>
                </div>
                ))}
                
                
              </div>
            </div>
          </div>
    </InfoBackgroudWrapper>
  );
};
